// Obtener la IP/localhost

const CONFIG = {

    //BASE_URL: 'http://localhost:3000/',
    //API_URL: 'http://localhost/tresatec/chatbot%20-%20copia/chatbot/API/',
   BASE_URL: 'https://chatbot.tresatec.com.ar/',
    API_URL: 'https://chatbot.tresatec.com.ar/API/',


  };
  
export default CONFIG;

